import entityApiUrl from '../entity/baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'

export type RegistryAsset = {
  entityId: string
  logId: string
  publishingOrgId: string
  name: string
  kind: string
  latestVersionId: string
  firstPublishedAt: number
}

export type RegistryAssetPage = {
  documents: RegistryAsset[]
  next: string | null
}

type ListRegistryAssetsParameters = {
  kind?: string
  search?: string
  cursor?: string
  pageSize?: number
  signal?: AbortSignal
}

const listRegistryAssets = async ({
  kind,
  search,
  cursor,
  pageSize = 50,
  signal,
}: ListRegistryAssetsParameters): Promise<RegistryAssetPage> => {
  const params = new URLSearchParams({ pageSize: pageSize.toString() })
  if (cursor) params.append('cursor', cursor)
  if (kind) params.append('kind', kind)
  if (search) params.append('search', search)

  const response = await fetchAuthorized(`${entityApiUrl}/registry/assets?${params.toString()}`, {
    method: 'GET',
    signal,
  })
  if (response.status !== 200) {
    throw Error(`Unexpected response code ${response.status} from listRegistryAssets endpoint`)
  }
  return (await response.json()) as RegistryAssetPage
}

export default listRegistryAssets
